export default {fields:{containerSchemas:{spreads:{ContainerSchema:{}}}},typenameResolver:'QueryTypenameResolver'}